var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoLive = function SvgIcoLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M3 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-.8 2.2a1 1 0 0 1 1-1h17.6a1 1 0 0 1 1 1v9.6a1 1 0 0 1-1 1H3.2a1 1 0 0 1-1-1zm3.65 7.3V7.74h1.006v3.93h2.04v.83zm3.694 0V8.93h.99v3.57zm.498-4.03a.54.54 0 0 1-.38-.147.48.48 0 0 1-.155-.356q0-.204.156-.35a.53.53 0 0 1 .379-.15q.22 0 .376.15a.472.472 0 0 1 0 .707.53.53 0 0 1-.376.146m4.614.46-1.248 3.57h-1.116l-1.248-3.57h1.046l.742 2.554h.037l.739-2.554zm2.019 3.64q-.551 0-.948-.223a1.53 1.53 0 0 1-.61-.637 2.1 2.1 0 0 1-.213-.979q0-.551.214-.967a1.6 1.6 0 0 1 .602-.648q.39-.233.915-.233.354 0 .658.114.307.112.535.337.23.226.358.567t.128.795v.272h-2.432v.003q0 .265.098.457.1.194.281.298.181.105.43.105.165 0 .302-.047a.606.606 0 0 0 .384-.367l.916.06a1.25 1.25 0 0 1-.286.577q-.214.244-.553.38-.337.135-.78.136m-.693-2.566a.8.8 0 0 0-.099.35h1.499a.76.76 0 0 0-.094-.378.67.67 0 0 0-.258-.258.74.74 0 0 0-.378-.096.76.76 0 0 0-.4.105.73.73 0 0 0-.27.277",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M12.2 16.5H11v1.9H4.2a.6.6 0 1 0 0 1.2H19a.6.6 0 1 0 0-1.2h-6.8z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoLive;